import { useState, useEffect } from "react"

export const ScrollDirection = {
  LEFT: "left",
  RIGHT: "right",
  TOP: "top",
  BOTTOM: "bottom",
} as const

export type ScrollDirectionType =
  (typeof ScrollDirection)[keyof typeof ScrollDirection]

export function useScroll(scrollRef: React.RefObject<HTMLElement | null>) {
  const [horizontal, setHorizontal] = useState({ left: false, right: false })
  const [vertical, setVertical] = useState({ top: false, bottom: false })
  const [scrollDirection, setScrollDirection] = useState<ScrollDirectionType[]>(
    []
  )

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return

    const update = () => {
      const {
        scrollTop,
        scrollHeight,
        clientHeight,
        scrollLeft,
        scrollWidth,
        clientWidth,
      } = el

      setHorizontal({
        left: scrollLeft > 0,
        right: scrollLeft + clientWidth < scrollWidth,
      })

      setVertical({
        top: scrollTop > 0,
        bottom: scrollTop + clientHeight < scrollHeight,
      })

      setScrollDirection([
        ...(scrollLeft > 0 ? [ScrollDirection.LEFT] : []),
        ...(scrollLeft + clientWidth < scrollWidth
          ? [ScrollDirection.RIGHT]
          : []),
        ...(scrollTop > 0 ? [ScrollDirection.TOP] : []),
        ...(scrollTop + clientHeight < scrollHeight
          ? [ScrollDirection.BOTTOM]
          : []),
      ])
    }

    update()
    el.addEventListener("scroll", update)
    return () => el.removeEventListener("scroll", update)
  }, [scrollRef])

  return { horizontal, vertical, scrollDirection }
}
